import {
    useState, SetStateAction, Dispatch,
} from 'react'

import {
    contactSelectionConfig,
} from 'app/requests/Contact/Contact.requests'
import useGetContactByIds from 'app/requests/Contact/hooks/useGetContactByIds'
import useDelayedLoadOptions, {
    DelayedLoadOptions,
} from 'app/hooks/useDelayedLoadOptions'
import {
    ArchiveStatus,
} from 'app/enums/common.enums'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import {
    Contact,
} from 'app/types/common.types'

import contactParser from '../utils/contactParser'

export type Value = {
    id: number,
}

type Args = {
    valueConverter: (value: number[] | { id: number }[]) => number[]
    includeFilters?: { type?: string[] },
    filters?: { type?: string[] },
    listIds: { id: number }[] | number[],
    archivedStatus?: ArchiveStatus,
}

const EMPTY_OBJECT = {}

const useCommonMultiContactSelectorLogic = ({
    valueConverter,
    includeFilters = EMPTY_OBJECT,
    filters = EMPTY_OBJECT,
    listIds,
    archivedStatus = ArchiveStatus.ALL,
}: Args): {
    contacts: Contact[],
    setContacts: Dispatch<SetStateAction<Contact[]>>,
    loadOptions: (options: DelayedLoadOptions) => Promise<any>,
    contactsByIds: Contact[],
    onError: (e: any) => void
} => {
    const [
        contacts,
        setContacts,
    ] = useState<Contact[]>()

    const {
        onError,
    } = useHandleStatusRequest({
        id: 'Contacts',
    })

    const loadOptions = useDelayedLoadOptions({
        url: contactSelectionConfig.url,
        convertion: contactParser,
        includeFilters,
        filters,
        params: {
            archivedStatus: ArchiveStatus.ACTIVE,
        },
    })

    const {
        data: contactsByIds, error,
    } = useGetContactByIds({
        ids: valueConverter(listIds),
        archivedStatus,
    })

    if (error) {
        onError(error)
    }

    return {
        contacts,
        setContacts,
        loadOptions,
        contactsByIds: listIds.length ? contactsByIds : [],
        onError,
    }
}

export default useCommonMultiContactSelectorLogic
